import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../ui/Logo';
import { Mail, Clock, Linkedin, Twitter, Facebook, ShieldCheck } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-slate-900 text-slate-300 pt-16 pb-8" data-id="element-136">
      <div className="container mx-auto px-4 md:px-6" data-id="element-137">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-138">
          {/* Brand Column */}
          <div data-id="element-139">
            <Link to="/" className="inline-block mb-6" data-id="element-140">
              <Logo variant="white" data-id="element-141" />
            </Link>
            <p className="text-slate-400 mb-6 leading-relaxed" data-id="element-142">
              Secure, cloud-based tools helping UK businesses coordinate teams
              and share files effortlessly.
            </p>
            <div className="flex gap-4" data-id="element-143">
              <a href="#" className="p-2 bg-slate-800 rounded-full hover:bg-teal-600 transition-colors" aria-label="LinkedIn" data-id="element-144">
                <Linkedin size={18} data-id="element-145" />
              </a>
              <a href="#" className="p-2 bg-slate-800 rounded-full hover:bg-teal-600 transition-colors" aria-label="Twitter" data-id="element-146">
                <Twitter size={18} data-id="element-147" />
              </a>
              <a href="#" className="p-2 bg-slate-800 rounded-full hover:bg-teal-600 transition-colors" aria-label="Facebook" data-id="element-148">
                <Facebook size={18} data-id="element-149" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-150">
            <h3 className="text-white font-semibold text-lg mb-6" data-id="element-151">Company</h3>
            <ul className="space-y-3" data-id="element-152">
              <li data-id="element-153">
                <Link to="/" className="hover:text-teal-400 transition-colors" data-id="element-154">
                  Home
                </Link>
              </li>
              <li data-id="element-155">
                <Link to="/services" className="hover:text-teal-400 transition-colors" data-id="element-156">
                  Services
                </Link>
              </li>
              <li data-id="element-157">
                <Link to="/about" className="hover:text-teal-400 transition-colors" data-id="element-158">
                  About Us
                </Link>
              </li>
              <li data-id="element-159">
                <Link to="/contact" className="hover:text-teal-400 transition-colors" data-id="element-160">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-161">
                <Link to="/faqs" className="hover:text-teal-400 transition-colors" data-id="element-162">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div data-id="element-163">
            <h3 className="text-white font-semibold text-lg mb-6" data-id="element-164">Legal</h3>
            <ul className="space-y-3" data-id="element-165">
              <li data-id="element-166">
                <Link to="/privacy-cookie-policy" className="hover:text-teal-400 transition-colors" data-id="element-167">
                  Privacy & Cookie Policy
                </Link>
              </li>
              <li data-id="element-168">
                <Link to="/terms-conditions" className="hover:text-teal-400 transition-colors" data-id="element-169">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-170">
                <Link to="/cancellation-policy" className="hover:text-teal-400 transition-colors" data-id="element-171">
                  Cancellation Policy
                </Link>
              </li>
              <li data-id="element-172">
                <Link to="/refund-policy" className="hover:text-teal-400 transition-colors" data-id="element-173">
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-174">
            <h3 className="text-white font-semibold text-lg mb-6" data-id="element-175">
              Get in Touch
            </h3>
            <ul className="space-y-4" data-id="element-176">
              <li className="flex items-start gap-3" data-id="element-177">
                <Mail className="w-5 h-5 text-teal-500 mt-0.5 flex-shrink-0" data-id="element-178" />
                <a href="mailto:lbhuwan151@gmail.com" className="hover:text-teal-400 transition-colors break-all" data-id="element-179">
                  lbhuwan151@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-180">
                <Clock className="w-5 h-5 text-teal-500 mt-0.5 flex-shrink-0" data-id="element-181" />
                <div data-id="element-182">
                  <div data-id="element-183">Mon–Fri: 9am – 5pm</div>
                  <div className="text-slate-500 text-sm" data-id="element-184">Sat–Sun: Closed</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-185">
          <p className="text-sm text-slate-500" data-id="element-186">
            © {currentYear} HomeLinkPro. All rights reserved.
          </p>
          <div className="flex items-center gap-2 text-sm text-slate-500" data-id="element-187">
            <ShieldCheck className="w-4 h-4" data-id="element-188" />
            <span data-id="element-189">Secure UK Platform</span>
          </div>
        </div>
      </div>
    </footer>;
}